// adding able-wrapper class to the table created by WYSIWYG

window.addEventListener('DOMContentLoaded', () => {
  const tables = document.querySelectorAll('table');

  if (!tables.length > 0) return;

  tables.forEach((table) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('table-wrapper');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
});
